import getQueryParams from './getQueryParams';

const getQueryParam = name => getQueryParams()[name];

export default getQueryParam;